<style>
.placement .vview-formitem {
    margin-bottom: 6px;
}
</style>

<template>
    <!-- 补发 -->
    <div
        :class="{
            placement:
                type == 'query' ||
                oldreplacementStatus == 'REPLACEMENTING' ||
                oldreplacementStatus == 'NULLIFY' ||
                oldreplacementStatus == 'REPLACEMENTED',
        }"
    >
        <div class="margin-20 clearfix">
            <header
                class="font-14 font-bold padding-bottom-10 b2ccolor-warning"
            >
                {{
                    $t("erp.aftersales.replaceorder", {
                        defaultValue: "补发单",
                    })
                }}
                <a
                    class="font-12 margin-right-10"
                    @click="jumpb2corder(formData.replacementOrderId)"
                    >{{ formData.replacementOrderNo }}</a
                >
                <span
                    v-if="type == 'query'"
                    class="font-12 b2color-black margin-right-10"
                >
                    (
                    <span>{{ filterStatus(formData.replacementStatus) }}</span>
                    )
                </span>
            </header>
            <vForm
                :label-width="120"
                style="min-height: 30px"
                :model="formData"
                class="clearfix"
                ref="replaceform"
            >
                <vCol span="12">
                    <div style="height: 30px">
                        <vFormItem
                            v-if="
                                type != 'query' &&
                                !(
                                    oldreplacementStatus == 'REPLACEMENTING' ||
                                    oldreplacementStatus == 'NULLIFY' ||
                                    oldreplacementStatus == 'REPLACEMENTED'
                                )
                            "
                            :label="
                                $t('erp.aftersales.addreplace', {
                                    defaultValue: '添加补发产品',
                                })
                            "
                            class="pull-left"
                            style="width: 360px"
                        >
                            <Select
                                clearable
                                filterable
                                v-model="searchErpSku"
                                ref="zierpselect"
                                remote
                                :remote-method="remoteMethod1"
                                @on-change="getSellerSKU(searchErpSku)"
                            >
                                <Option
                                    v-for="json in erpSkusList"
                                    :value="json.erpSku"
                                    :key="json.productId"
                                    >{{ json.erpSku }}</Option
                                >
                            </Select>
                        </vFormItem>
                        <div
                            v-if="
                                type != 'query' &&
                                !(
                                    oldreplacementStatus == 'REPLACEMENTING' ||
                                    oldreplacementStatus == 'NULLIFY' ||
                                    oldreplacementStatus == 'REPLACEMENTED'
                                )
                            "
                            class="pull-left margin-left-10"
                        >
                            <vButton slot="append" @click="showInvatryBox">{{
                                $t("global.common.add", {
                                    defaultValue: "添加",
                                })
                            }}</vButton>
                        </div>
                    </div>
                </vCol>
                <vCol span="12">
                    <div class="pull-right margin-bottom-20">
                        <div
                            v-if="
                                type != 'query' &&
                                (oldreplacementStatus == 'REPLACEMENTED' ||
                                    oldreplacementStatus == 'NULLIFY')
                            "
                        >
                            {{ filterStatus(formData.replacementStatus) }}
                        </div>
                        <vSelect
                            v-if="
                                type != 'query' &&
                                !(
                                    oldreplacementStatus == 'REPLACEMENTED' ||
                                    oldreplacementStatus == 'NULLIFY'
                                )
                            "
                            v-model="formData.replacementStatus"
                            style="width: 120px"
                        >
                            <vOption
                                value="NOREPLACEMENT"
                                v-show="oldreplacementStatus == 'NOREPLACEMENT'"
                                >{{
                                    $t("erp.aftersales.noreplacement", {
                                        defaultValue: "未补发",
                                    })
                                }}</vOption
                            >
                            <vOption
                                value="REPLACEMENTING"
                                v-show="oldreplacementStatus != 'NULLIFY'"
                                >{{
                                    $t("erp.aftersales.replacementing", {
                                        defaultValue: "待补发",
                                    })
                                }}</vOption
                            >
                            <!-- <vOption value="REPLACEMENTED" v-show=" ">已补发</vOption> -->
                            <vOption value="NULLIFY">{{
                                $t("erp.aftersales.nullify", {
                                    defaultValue: "已作废",
                                })
                            }}</vOption>
                        </vSelect>
                    </div>
                </vCol>
                <vCol span="24">
                    <vTable
                        class="margin-bottom-20"
                        :columns="columns"
                        :data="datalist"
                        size="small"
                        ref="table"
                        border
                    ></vTable>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.search_outwarehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.orgWarehouseCode }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.search_outwarehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                        :rules="required"
                        prop="orgWarehouseCode"
                    >
                        <Select
                            clearable
                            filterable
                            v-model="formData.orgWarehouseCode"
                            @on-change="getWarehouseCarrierList"
                        >
                            <Option value="AUTO">System Auto</Option>
                            <Option
                                v-for="json in warehouseList"
                                :value="json.code"
                                :key="json.id"
                                >{{ json.title }} ({{ json.code }})</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.shippingMode }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        :rules="required"
                        prop="shippingMode"
                    >
                        <Select
                            clearable
                            filterable
                            v-model="formData.shippingMode"
                        >
                            <Option value="AUTO">System Auto</Option>
                            <Option
                                v-for="(json, index) in warehouseCarrierList"
                                :value="json.value"
                                :key="index"
                                >{{ json.label }}</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.recipients', { defaultValue: '收件人' })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.name }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.recipients', { defaultValue: '收件人' })
                        "
                        :rules="required"
                        prop="name"
                    >
                        <vInput v-model="formData.name"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.country }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $tc('global.common.country', 1, {
                                defaultValue: '国家',
                            })
                        "
                        :rules="required"
                        prop="country"
                    >
                        <Select
                            clearable
                            filterable
                            v-model="formData.country"
                            @on-change="oneCountry(formData.country, 'edit')"
                        >
                            <Option
                                v-for="(json, index) in countries"
                                :value="json.code"
                                :key="index"
                                >{{ json.code }}</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.address1 }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2border.addressone', {
                                defaultValue: '地址1',
                            })
                        "
                        :rules="required"
                        prop="address1"
                    >
                        <vInput v-model="formData.address1"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.state }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.state_province', {
                                defaultValue: '州/省份',
                            })
                        "
                        :rules="required"
                        prop="state"
                    >
                        <div>
                            <AutoComplete
                                v-model="formData.state"
                                :data="states"
                                :filter-method="filterMethod"
                            ></AutoComplete>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2border.addresstwo', {
                                defaultValue: '地址2',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreplacementStatus == 'REPLACEMENTING' ||
                                oldreplacementStatus == 'NULLIFY' ||
                                oldreplacementStatus == 'REPLACEMENTED'
                            "
                        >
                            {{ formData.address2 }}
                        </div>
                        <vInput v-else v-model="formData.address2"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.postal }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('erp.b2c.zip_code', { defaultValue: '邮编' })
                        "
                        :rules="required"
                        prop="postal"
                    >
                        <vInput v-model="formData.postal"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.city }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="$t('erp.b2c.city', { defaultValue: '城市' })"
                        :rules="required"
                        prop="city"
                    >
                        <vInput v-model="formData.city"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        v-if="
                            type == 'query' ||
                            oldreplacementStatus == 'REPLACEMENTING' ||
                            oldreplacementStatus == 'NULLIFY' ||
                            oldreplacementStatus == 'REPLACEMENTED'
                        "
                    >
                        <div class="font-bold height-32">
                            {{ formData.phone }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="$t('erp.b2c.phone', { defaultValue: '电话' })"
                        :rules="required"
                        prop="phone"
                    >
                        <vInput v-model="formData.phone"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="24">
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('erp.aftersales.replacementAt', {
                                    defaultValue: '补发时间',
                                })
                            "
                            v-if="
                                type == 'query' ||
                                oldreplacementStatus == 'REPLACEMENTING' ||
                                oldreplacementStatus == 'NULLIFY' ||
                                oldreplacementStatus == 'REPLACEMENTED'
                            "
                        >
                            <div class="font-bold height-32">
                                {{ formData.replacementAt }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            v-else
                            :label="
                                $t('erp.aftersales.replacementAt', {
                                    defaultValue: '补发时间',
                                })
                            "
                            :rules="required"
                            prop="replacementAt"
                        >
                            <vDatepicker
                                v-model="formData.replacementAt"
                                format="yyyy-mm-dd HH:MM:SS"
                                style="width: 100%"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('erp.distribution.issignature', {
                                    defaultValue: '是否签收',
                                })
                            "
                        >
                            <div
                                class="font-bold height-32"
                                v-if="
                                    type == 'query' ||
                                    oldreplacementStatus == 'REPLACEMENTING' ||
                                    oldreplacementStatus == 'NULLIFY' ||
                                    oldreplacementStatus == 'REPLACEMENTED'
                                "
                            >
                                {{
                                    formData.carrierAddition === "YES"
                                        ? $t("erp.global.yes", {
                                              defaultValue: "是",
                                          })
                                        : $t("erp.global.no", {
                                              defaultValue: "否",
                                          })
                                }}
                            </div>
                            <Select
                                v-else
                                clearable
                                filterable
                                v-model="formData.carrierAddition"
                            >
                                <Option value="YES">{{
                                    $t("erp.global.yes", { defaultValue: "是" })
                                }}</Option>
                                <Option value="NO">{{
                                    $t("erp.global.no", { defaultValue: "否" })
                                }}</Option>
                            </Select>
                        </vFormItem>
                    </vCol>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.aftersales.replaceremark', {
                                defaultValue: '补发原因',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreplacementStatus == 'REPLACEMENTING' ||
                                oldreplacementStatus == 'NULLIFY' ||
                                oldreplacementStatus == 'REPLACEMENTED'
                            "
                        >
                            {{ formData.replacementExplain }}
                        </div>
                        <vTextarea
                            v-else
                            v-model="formData.replacementExplain"
                            style="width: 100%"
                            :placeholder="
                                $t('boss.aftersales.inputs_are_allowed', {
                                    defaultValue: '最多可输入100个字',
                                })
                            "
                            maxlength="100"
                        ></vTextarea>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('fbb.costmanage.explain', {
                                defaultValue: '说明',
                            })
                        "
                    >
                        <div
                            class="font-bold height-32"
                            v-if="
                                type == 'query' ||
                                oldreplacementStatus == 'REPLACEMENTING' ||
                                oldreplacementStatus == 'NULLIFY' ||
                                oldreplacementStatus == 'REPLACEMENTED'
                            "
                        >
                            {{ formData.remark }}
                        </div>
                        <vTextarea
                            v-else
                            v-model="formData.remark"
                            style="width: 100%"
                            :placeholder="
                                $t('boss.aftersales.inputs_are_allowed', {
                                    defaultValue: '最多可输入100个字',
                                })
                            "
                            maxlength="100"
                        ></vTextarea>
                    </vFormItem>
                </vCol>
            </vForm>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetrePush,
    HttpGetFlagAndSku,
    HttpGetErpsku,
    HttpWarehouseCarrierList,
} from "@/service/aftersales/aftersales";
import {
    HttpFindWarehouseCarriers,
    HttpGetStates,
    HttpFindTruckWarehouseCarriers,
    HttpGetOrgWarehouseCode,
} from "@/service/boss/b2corder";
import { HttpGetContry } from "@/service/boss/dictionary";
import { HttpPlatformSystem } from "@/service/managechannel/managechannel";
export default {
    props: [
        "orderServiceReplacement",
        "accountFlag",
        "tabledata",
        "comtype",
        "indexid",
        "querytype",
    ],
    components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            datalist: [],
            type: this.$route.params.type,
            id: this.$route.query.id,
            searchErpSku: "",
            erpSkusList: [],
            formData: {
                orgWarehouseCode: "AUTO",
                shippingMode: "AUTO",
                replacementStatus: "NOREPLACEMENT",
                carrierAddition: "NO",
            },
            warehouseCarrierList: [],
            otherWarehouseCarrierList: [], //其他仓库发运方式
            states: [],
            loading1: false,
            required: [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            addgoodsData: [],
            oldreplacementStatus: "NOREPLACEMENT",
            additemShow: false,
        };
    },
    created() {
        this.datalist = this.tabledata.concat();

        // console.log(this.orderServiceReplacement)
        let {
            name,
            country,
            address1,
            state,
            postal,
            city,
            phone,
            carrierAddition = "NO",
        } = this.orderServiceReplacement;
        this.formData = {
            name,
            country,
            state,
            postal,
            city,
            phone,
            carrierAddition,
        };
        this.formData.address1 = address1;
        this.formData.orgWarehouseCode = "AUTO";
        this.formData.shippingMode = "AUTO";
        this.formData.replacementStatus = "NOREPLACEMENT";
        // this.getRegoodsMode();
        this.getdata();

        if (this.comtype == "query") {
            this.type = this.comtype;
            this.id = this.indexid;
        } else if (this.querytype == "query") {
            this.type = this.querytype;
            this.id = this.indexid;
        } else {
            this.type = this.type;
        }
    },
    watch: {
        orderServiceReplacement: {
            deep: true,
            handler(val) {
                // console.log(val)
                this.formData = { ...this.formData, ...val };
                // this.formData.address1 = this.formData.address1

                if (this.tabledata) {
                    this.datalist = this.tabledata.concat();
                }
                if (this.$route.params.type == "add") {
                    this.formData.orgWarehouseCode = "AUTO";
                    this.formData.shippingMode = "AUTO";
                }

                if (!val.replacementAt) {
                    this.getdata();
                }
                if (!val.replacementStatus) {
                    this.formData.replacementStatus = "NOREPLACEMENT";
                    this.oldreplacementStatus = "NOREPLACEMENT";
                } else {
                    this.oldreplacementStatus = val.replacementStatus;
                }
                if (this.type == "edit") {
                    this.oneCountry(val.country);
                }
            },
        },
    },
    computed: {
        ...mapState("boss", ["accounts", "warehouseList", "countries"]),
        columns() {
            let _this = this;
            return [
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                // {
                //     title: "Seller SKU",
                //     key:'sellerSku'
                // },
                {
                    // title: "",
                    key: "replacementNum",
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.oldreplacementStatus == "REPLACEMENTING" ||
                            _this.oldreplacementStatus == "NULLIFY" ||
                            _this.oldreplacementStatus == "REPLACEMENTED"
                        ) {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.replacement_num", {
                                        defaultValue: "补发数量",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.replacement_num", {
                                        defaultValue: "补发数量",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldreplacementStatus == "REPLACEMENTING" ||
                            _this.oldreplacementStatus == "NULLIFY" ||
                            _this.oldreplacementStatus == "REPLACEMENTED"
                        ) {
                            return <div>{row.replacementNum}</div>;
                        } else {
                            return h("vInput", {
                                props: {
                                    size: "small",
                                    value: row.replacementNum,
                                },
                                on: {
                                    input: (event) => {
                                        row.replacementNum = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        }
                    },
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    width:
                        _this.type == "query" ||
                        _this.oldreplacementStatus == "REPLACEMENTING" ||
                        _this.oldreplacementStatus == "NULLIFY" ||
                        _this.oldreplacementStatus == "REPLACEMENTED"
                            ? 0
                            : 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                },
                                this.$t("global.common.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        getdata() {
            let gmttome = this.$moment()
                .tz("GMT")
                .format("YYYY-MM-DD HH:mm:ss");
            this.formData.replacementAt = gmttome;
        },
        remoteMethod1(query) {
            this.loading1 = true;
            HttpGetErpsku({ "search[CN_erpSku]": query, rows: 50 }).then(
                (res) => {
                    // console.log(res)
                    this.loading1 = false;
                    this.erpSkusList = res.data.content.map((item) => {
                        return {
                            erpSku: item.erpSku,
                            title: item.nameEn,
                            productId: item.id,
                            isInsurance: item.isInsurance,
                            insuranceRate: item.insuranceRate,
                        };
                    });
                }
            );
        },
        /**
         * 仓库发运方式，仓库类型auto
         */
        // getRegoodsMode(){
        //     HttpPlatformSystem({
        //         page: 1,
        //         rows: 500,
        //         sidx: 'id',
        //         sord: 'desc',
        //         // orderType:200
        //     }).then(res=>{
        //         // console.log(res)
        //         this.warehouseCarrierList=this.otherWarehouseCarrierList = res.data.content||[]
        //     })
        // },
        /**
         * 仓库发运方式
         */
        getWarehouseCarrierList(warehouseCode) {
            if (warehouseCode === "AUTO") {
                this.warehouseCarrierList = this.otherWarehouseCarrierList;
                return;
            }
            HttpGetOrgWarehouseCode({
                orgId: global.SYSID,
                warehouseCode: warehouseCode,
            }).then(
                (res) => {
                    this.warehouseCarrierList = res.data.map((item) => {
                        return {
                            label: `${item.code}(${item.carrierServiceName})`,
                            value: item.code,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {}
            );
        },
        getSellerSKU(erpsku) {
            this.additemShow = false;
            this.addgoodsData = this.erpSkusList.find(
                (item) => item.erpSku === erpsku
            );
            // HttpGetFlagAndSku({
            //     accountFlag:this.accountFlag,
            //     erpSku:erpsku,
            // }).then(res => {
            //     // console.log(res)
            //     this.additemShow = false
            //     this.addgoodsData = res.data
            // },err=>{
            //     this.additemShow = true
            // });
        },
        filterMethod(value, option) {
            return option.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        oneCountry(code, type) {
            HttpGetContry({
                "search[EQ_depth]": 2,
                "search[EQ_code]": code,
            }).then(
                (res) => {
                    let onecode = res.data[0];
                    this.getStates(onecode.id, type);
                },
                (err) => {}
            );
        },
        getStates(parid, type) {
            if (type == "edit") {
                this.formData.state = "";
            }
            this.states = [];
            HttpGetStates({
                "search[EQ_depth]": 4,
                "search[EQ_parentId]": parid,
            }).then(
                (res) => {
                    let array = res.data;
                    array.map((item) => {
                        this.states.push(item.code);
                    });
                },
                (err) => {}
            );
        },
        getwarehouseCarry(value) {
            if (value == null || value == undefined || value == "AUTO") {
                return;
            }
        },
        showInvatryBox() {
            if (this.additemShow == false) {
                let data = {
                    productId: this.addgoodsData.productId,
                    erpSku: this.addgoodsData.erpSku,
                    isInsurance:
                        this.addgoodsData.isInsurance === "N" ? "NO" : "YES",
                    insuranceRate: this.addgoodsData.insuranceRate,
                    // sellerSku:this.addgoodsData.sellerSku,
                    replacementNum: 0,
                };
                this.datalist.push(data);
            }
        },
        remove(index) {
            this.datalist.splice(index, 1);
        },
        repush() {
            HttpGetrePush({
                id: this.id,
            }).then(
                (res) => {
                    // message
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        jumpb2corder(order) {
            const url = this.$router.resolve({
                name: "b2cOrderupdate",
                params: { type: "query" },
                query: { id: order },
            });
            window.open(url.href, "_blank");
        },
        async validate() {
            const bool1 = await this.$refs["replaceform"].validate();
            if (!bool1) {
                this.$VMessage.warning(
                    this.$t("global.form.require", {
                        defaultValue: "请填写必填项",
                    })
                );
            }
            return bool1;
        },
        filterStatus(val) {
            let status;
            switch (val) {
                case "NOREPLACEMENT":
                    status = this.$t("erp.aftersales.noreplacement", {
                        defaultValue: "未补发",
                    });
                    break;
                case "REPLACEMENTING":
                    status = this.$t("erp.aftersales.replacementing", {
                        defaultValue: "待补发",
                    });
                    break;
                case "REPLACEMENTED":
                    status = this.$t("erp.aftersales.replacemented", {
                        defaultValue: "已补发",
                    });
                    break;
                case "NULLIFY":
                    status = this.$t("erp.aftersales.nullify", {
                        defaultValue: "已作废",
                    });
                    break;
            }
            return status;
        },
    },
};
</script>
